import {
Button,
Dialog,
DialogHeader,
DialogBody,
DialogFooter,
} from "@material-tailwind/react";
import { useTranslation } from "@refinedev/core";

const DialogConfirm = (props: any) => {
const { open, setOpen, dialogMessage, setSubmitAction, isMobile } = props;
const { translate } = useTranslation();

return (
  <Dialog
    open={open}
    handler={() => setOpen(!open)}
    animate={{
      mount: { scale: 1, y: 0 },
      unmount: { scale: 0.9, y: -100 },
    }}
    id="dialog-confirm"
    className={`!border-none !outline-none ${isMobile ? 'px-[16px] py-[32px] !w-[calc(100%-32px)] !min-w-[calc(100%-32px)] !max-w-[calc(100%-32px)] rounded-[8px]' : 'p-[32px] !w-[570px] !min-w-[570px] !max-w-[570px]'}`}
    {...{} as any}
  >
    <DialogHeader
      {...{} as any}>{translate('notification')}</DialogHeader>
    <DialogBody
      {...{} as any}>
      {dialogMessage}
    </DialogBody>
    <DialogFooter
      {...{} as any} >
      <Button
        className="h-[48px] flex items-center justify-center border border-brand-500 bg-white !text-14 !font-500 text-brand-500 mr-[12px]"
        {...{} as any}
        onClick={() => setOpen(!open)}>{translate('btn-cancel')}</Button>
      <Button
        {...{} as any}
        className="h-[48px] flex items-center justify-center border border-brand-500 bg-brand-500 !text-14 !font-500 text-white" onClick={() => {
          setSubmitAction(true);
          setOpen(!open);
        }}>{translate('btn-submit')}</Button>
    </DialogFooter>
  </Dialog>
)
}

export default DialogConfirm;